import React, { useState, useEffect } from 'react';
import { useFormik } from "formik";
import * as Yup from 'yup';
import { KTSVG } from '_metronic/helpers';
import { toast } from 'react-toastify';
import DateComponent from 'app/components/FormComponents/DateComponent';
import SelectComponent from 'app/components/FormComponents/SelectComponent';
import NumericComponent from 'app/components/FormComponents/NumericComponent';
import Tooltip from 'app/components/Tooltip';
import axios from 'axios';
import { SelectOption } from 'app/types/commons';
import { styleSelect } from '_metronic/helpers/SelectStyles';
import Select from 'react-select';
import { EmployeeResponse } from 'app/types/employee';
import { Collaborator } from 'app/types/collaborator';
import { toaster } from 'app/utilities/commons';
const API_URL = process.env.REACT_APP_API_NET;

type Props = {
    collaborator?: Collaborator;
    refetch: () => void;
};

type Empleo = {
    id?: number | null,
    dateBegin?: string,
    dateEnd?: string,
    position?: string,
    departamento?: SelectOption | null,
    baseSalary?: number | string,
    dayliSalary?: number | string,
    profile?: SelectOption | null,
    actual: boolean,
};

const initialValues: Empleo = {
    id: null,
    dateBegin: '',
    dateEnd: '',
    position: '',
    departamento: null,
    baseSalary: 0,
    dayliSalary: 0,
    profile: null,
    actual: false,
};

// const hoy = new Date();
// hoy.setDate(hoy.getDate() + 30);
// .min("1900-01-01", "Fecha no valida").max(hoy.setDate(hoy.getDate() + 30),"Fecha no valida")
const validationSchema = Yup.object({
    dateBegin: Yup.date().required('Este campo es requerido')
               .min("2000-01-01","Fecha no valida")
               .max("2030-01-01","Fecha no valida"),
    // dateBegin: Yup.date()
    //            .required('Este campo es requerido')
    //            .min("1900-01-01","Fecha no valida")
    //            .max("2010-01-01","RGHJ"),
    position: Yup.string().required('Este campo es requerido'),
    departamento: Yup.object({
        value: Yup.number(),
        label: Yup.string(),
    })
        .nullable()
        .required('Este campo es requerido'),
    profile: Yup.object({
        value: Yup.number(),
        label: Yup.string(),
    })
        .nullable()
        .required('Este campo es requerido'),
    baseSalary: Yup.number().min(1, 'Tiene que ser mayor a 0').required('Este campo es requerido'),
});

    const JobsList: React.FC<Props> = ({ collaborator, refetch }) => {
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState<SelectOption[]>([]);
    const [department, setDepartment] = useState<SelectOption[]>([]);
    const [newRow, setNewRow] = useState(false);
    const [prevData, setPrevData] = useState<any>([]);
    const getPrevJobs = async () => {
        try {
            const { data: { data: jobs } } = await axios.get<EmployeeResponse>(`${API_URL}Employe/${collaborator?.id}/collaborator`);
            const sortedJobs = jobs
                .sort((a: any, b: any) => {
                    if (a.dateBegin! > b.dateBegin!) return 1;
                    else return -1;
                });
            setPrevData(sortedJobs.map((val, index) => (
                <tr key={`prev.${val.id}`}>
                    <td>
                        <input
                            type="date"
                            className={`form-control`}
                            value={val.dateBegin?.split('T')[0]}
                            disabled
                        />
                    </td>
                    <td>
                        <input
                            type="date"
                            className={`form-control`}
                            value={val.dateEnd?.split('T')[0]}
                            disabled
                        />
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px">
                                <Select
                                    value={profile.find((p: any) => p.value === val.profileId)}
                                    isDisabled
                                    options={profile}
                                    menuPortalTarget={document.body}
                                    menuPosition={"fixed"}
                                    styles={styleSelect}
                                    backspaceRemovesValue
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px" >
                                <input
                                    style={{
                                        textOverflow: "ellipsis",
                                    }}
                                    className="form-control"
                                    value={department.find((d) => d.value === val.departmentId)?.label}
                                    disabled
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px">
                                <input
                                    style={{
                                        textOverflow: "ellipsis",
                                    }}
                                    className="form-control"
                                    value={val.position}
                                    disabled
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column fs-012 text-gray-600 w-150px">
                                <input
                                    className="form-control"
                                    value={val.baseSalary.toFixed(2)}
                                    disabled
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column fs-012 text-gray-600 w-150px">
                                <input
                                    className="form-control"
                                    value={val.dayliSalary.toFixed(2)}
                                    disabled
                                />
                            </div>
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column fs-012 text-gray-600">
                                <input
                                    style={{ width: '30px', height: '30px' }}
                                    type="checkbox"
                                    disabled
                                    checked={val.id === collaborator?.employe?.id}
                                />
                            </div>
                        </div>
                    </td>
                </tr>
            )));  

        } catch (error) {
            console.error('error getting job data', error);
        }
    };
    const formData = useFormik<Empleo>({
        initialValues,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setLoading(true);
            try {
                await axios.post(`${API_URL}Employe`, {
                    collaboratorId: collaborator?.id,
                    profileId: values.profile?.value,
                    departmentId: values.departamento?.value,
                    dateBegin: values.dateBegin,
                    position: values.position,
                    baseSalary: values.baseSalary,
                });
                refetch();
                getPrevJobs();
                formData.resetForm();
          
                setNewRow(false);
                const message = 'Se actualizó la información de empleos con éxito';
                toast.success(message, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light',
                });
            } catch (error: any) {
                const defaultError = 'Hubo un error al intentar actualizar los datos de empleos';
                toaster.error(error.response.data.errors[0].message ?? defaultError);
            } finally {
                setLoading(false);
                setSubmitting(false);
            }
        },
    });
    const addRow = () => {
        setNewRow(true);
    };

    useEffect(() => {
        const asyncGet = async () => {
            try {
                const [profileRes, departmentRes] = await Promise.all([
                    axios.get(`${API_URL}Profile`),
                    axios.get(`${API_URL}Department`),
                ]);
                setDepartment(departmentRes.data.data.records.map((item: any) => ({
                    value: item.id,
                    label: item.description,
                })));
                setProfile(profileRes.data.data.records.map((item: any) => ({
                    value: item.id,
                    label: item.description,
                })));
            } catch (error) {
                console.error('error en carga de catalogos', error)
            }
        };
        asyncGet();
    }, []);

    const handleClose = () => {
        formData.resetForm();
        // setCountry({ value: 0, label: '' });
        // setEntity({ value: 0, label: '' });
        // setLocality({ value: 0, label: '' });
        // setColonies([]);
        // setShow(false);
    };

    useEffect(() => {
        if (collaborator?.id && profile.length && department.length) getPrevJobs();
    }, [collaborator, profile, department]);
    return (
        <div className="table-responsive min-h-300px me-n5 pe-5 scroll-y">
            <form onSubmit={formData.handleSubmit}>
                <table className="table table-border table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 me-n5 pe-5">
                    <thead>
                        <tr className="text-gray-800 fs-7">
                            <th className="w-150px">Fecha de alta</th>
                            <th className="w-200px">Fecha de planta</th>
                            <th className="w-350px">Tipo de Moneda</th>
                        </tr>
                    </thead>
                    <tbody className="">
                        <tr>
                            <td>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={collaborator?.employe?.dateBegin}
                                    disabled
                                />
                            </td>
                            <td>
                                <input
                                    type="date"
                                    className="form-control"
                                    disabled
                                />
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600">
                                        <input
                                            className='form-control'
                                            type='select'
                                            value="MXN-Pesos Mexicanos"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h5>Historial de puestos</h5>
                <table className="table table-border table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 me-n5 pe-5">
                    <thead>
                        <tr className="text-gray-800 fs-7">
                            <th className="required w-150px">Fecha inicio</th>
                            <th className="required w-200px">Fecha término</th>
                            <th className="required w-200px">Perfil Asociado</th>
                            <th className="w-350px text-start">Departamento</th>
                            <th className="required w-350px">Puesto</th>
                            <th className="w-150px">Sueldo Base</th>
                            <th className="w-150px">Salario Diario</th>
                            <th className="w-150px">Actual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(prevData.length || newRow) ? (
                            <>
                                {prevData}
                            </>
                        ) : (
                            <tr>
                                <td colSpan={9} className="text-center text-muted">
                                    Sin registros
                                </td>
                            </tr>
                        )}
                        <tr className={newRow ? '' : 'd-none'} style={{ marginLeft: 200 }}>
                            <td>
                                <DateComponent
                                    formData={formData}
                                    name="dateBegin"
                                    // disablePast
                                    leftTooltip={120}
                                    display={'-1'}
                                />
                                {formData.touched.dateBegin && formData.errors.dateBegin && (
                                    <div className="fv-plugins-message-container text-danger w-100">
                                        <span role="alert">{formData.errors.dateBegin}</span>
                                    </div>
                                )}
                            </td>
                            <td>
                                <input
                                    type="date"
                                    className={`form-control`}
                                    value=""
                                    disabled
                                />
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px">
                                        <SelectComponent
                                            formData={formData}
                                            name="profile"
                                            options={profile}
                                            display={'-1'}
                                        />
                                        {formData.touched.profile && formData.errors.profile && (
                                            <div className="fv-plugins-message-container text-danger w-100">
                                                <span role="alert">{formData.errors.profile}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px"
                                        style={{
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "150px",
                                        }}>
                                        <SelectComponent
                                            name="departamento"
                                            options={department}
                                            formData={formData}
                                            display={'-1'}
                                        />
                                        {formData.touched.departamento && formData.errors.departamento && (
                                            <div className="fv-plugins-message-container text-danger w-100">
                                                <span role="alert">{formData.errors.departamento}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start w-100 flex-column fs-012 font-weight-mormal text-gray-600 w-150px"
                                    >
                                        <Tooltip
                                            show={Boolean(formData.touched.position && formData.errors.position)}
                                            content={formData.errors.position}
                                            type='error'
                                            side='top'
                                            display={'-1'}
                                        >
                                            <input
                                                className="form-control"
                                                data-kt-element="input"
                                                name="position"
                                                value={formData.values.position}
                                                onChange={formData.handleChange}
                                                style={{
                                                    minWidth: "150px",
                                                }}
                                            />
                                        </Tooltip>
                                        {formData.touched.position && formData.errors.position && (
                                            <div className="fv-plugins-message-container text-danger w-100">
                                                <span role="alert">{formData.errors.position}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start flex-column fs-012 text-gray-600 w-150px">
                                        <NumericComponent
                                            formData={formData}
                                            name="baseSalary"
                                            allowNegative={false}
                                            display={'-1'}
                                        />
                                        {formData.touched.baseSalary && formData.errors.baseSalary && (
                                            <div className="fv-plugins-message-container text-danger w-100">
                                                <span role="alert">{formData.errors.baseSalary}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start flex-column fs-012 text-gray-600 w-150px">
                                        <NumericComponent
                                            formData={formData}
                                            name="dayliSalary"
                                            allowNegative={false}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex justify-content-start flex-column fs-012 text-gray-600">
                                        <input
                                            style={{ width: '30px', height: '30px' }}
                                            type="checkbox"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-light-primary btn-sm mb-10"
                        disabled={!collaborator}
                        type='button'
                        onClick={addRow}
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr075.svg"
                            className="svg-icon-5"
                        />
                        Agregar Empleo
                    </button>
                </div>
                <div className='text-end'>
                    <button
                        type="reset"
                        className="btn btn-light me-3"
                        onClick={handleClose}
                    >
                        Cancelar
                    </button>
                    <button
                        className="btn btn-primary me-6"
                        disabled={loading || !newRow}
                        type='submit'
                    >
                        {!loading && (
                            <span className="indicator-label">
                                Guardar
                            </span>
                        )}
                        {loading && (
                            <span className="indicator-progress" style={{ display: 'block' }}>
                                Espere por favor...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export { JobsList };
